export const REGISTERING = 'Registering';
